import {FC} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {GlobeIcon} from '@/components/common/icons/GlobeIcon'
import {theme} from '@/theme/theme'

type AllMarketsButtonProps = {
  title: string
  description: string
  onClick?: () => void
}

export const AllMarketsButton: FC<AllMarketsButtonProps> = ({title, description, onClick}) => {
  return (
    <>
      <button className="button" onClick={onClick} type="button" data-test="moreMarketsButton">
        <div className="icon">
          <GlobeIcon />
        </div>
        <Text fontWeight={TextFontWeight.semibold}>{title}</Text>
        <Text variant={TextVariant.caption} element="p">
          {description}
        </Text>
      </button>

      <style jsx>{`
        .button {
          width: 100%;
          margin-top: ${theme.spacing[3]};
          text-align: center;
          padding: ${theme.spacing[3]};
          border-radius: 12px;
          box-shadow: inset 0px 0px 0px 1px ${theme.palette.gray[200]};
          cursor: pointer;
        }
        .button:hover {
          background-color: ${theme.palette.gray[50]};
        }
        .icon {
          display: inline-block;
          margin-bottom: ${theme.spacing[1]};
        }
      `}</style>
    </>
  )
}
